<template>
  <div class="delete-account-page">
    <h1>Delete Account</h1>
    <p>Deleting your account is permanent and cannot be undone. All your data will be removed.</p>

    <div class="warning-box">
      <strong>Warning:</strong> This action is irreversible.
    </div>

    <button
      @click="confirmDelete"
      class="confirm-delete"
      aria-label="Confirm delete my account"
      data-track="delete_account_confirm_click"
      :data-track-props="JSON.stringify({ location:'delete_account_page' })"
    >
      Yes, Delete My Account
    </button>

    <button
      @click="$router.push({ name: 'AccountPage' })"
      aria-label="Cancel delete and go back to Account page"
      data-track="delete_account_cancel_click"
      :data-track-props="JSON.stringify({ location:'delete_account_page' })"
    >
      Cancel
    </button>
  </div>
</template>

<script>
import axios from 'axios';
import { logEvent } from '@/analytics'; // from src/analytics.js

export default {
  name: 'DeleteAccountPage',
  methods: {
    async confirmDelete() {
      // user clicked the confirm button (click itself is tracked via data-track)
      if (!confirm('Are you absolutely sure? This cannot be undone.')) return;

      await logEvent('delete_account_attempt', { route: 'DeleteAccountPage' });

      const token = localStorage.getItem('token');
      try {
        const res = await axios.post('/etherscan/delete_account.php', {}, {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (res.data?.status === 'success') {
          await logEvent('delete_account_success', { route: 'DeleteAccountPage' });

          alert('Your account has been deleted.');

          // Clear auth and session identifiers (keep session analytics sane)
          localStorage.removeItem('token');
          localStorage.removeItem('username');
          localStorage.removeItem('role');

          // Redirect hard to reset all state/UI
          this.$router.push('/signup');
          window.location.reload();
        } else {
          const msg = res?.data?.message || 'Unknown error';
          await logEvent('delete_account_error', { code:'api_fail', message: String(msg).slice(0,180) });
          alert('Error: ' + msg);
        }
      } catch (err) {
        console.error('Delete failed:', err);
        await logEvent('delete_account_error', { code:'network', message: String(err?.message || err).slice(0,180) });
        alert('An error occurred while deleting your account.');
      }
    }
  }
};
</script>


<style scoped>
.delete-account-page {
  max-width: 600px;
  margin: 40px auto;
  padding: 20px;
}

.warning-box {
  background-color: #ffebee;
  border: 1px solid #e53935;
  padding: 10px;
  margin: 20px 0;
  color: #c62828;
}

.confirm-delete {
  background-color: #e53935;
  color: white;
  border: none;
  padding: 10px 16px;
  margin-right: 10px;
  border-radius: 4px;
}

.confirm-delete:hover {
  background-color: #c62828;
}
</style>
